import React, { useEffect } from "react";
import PageTitle from "../../layout/PageTitle";
import Summary from "./Summary";
import Team from "./Team";

function About({ setTab }) {
  useEffect(() => {
    setTab("about");
  }, [setTab]);
  return (
    <>
      <PageTitle page="About Us" setTab={setTab} />
      <div className="site-main">
        <Summary />
        <Team setTab={setTab} />
      </div>
    </>
  );
}

export default About;
